import { render, staticRenderFns } from "./RecentWorksList.vue?vue&type=template&id=be57c112&scoped=true"
import script from "./RecentWorksList.vue?vue&type=script&lang=ts"
export * from "./RecentWorksList.vue?vue&type=script&lang=ts"
import style0 from "./RecentWorksList.vue?vue&type=style&index=0&id=be57c112&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be57c112",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be57c112')) {
      api.createRecord('be57c112', component.options)
    } else {
      api.reload('be57c112', component.options)
    }
    module.hot.accept("./RecentWorksList.vue?vue&type=template&id=be57c112&scoped=true", function () {
      api.rerender('be57c112', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/RecentWorksList.vue"
export default component.exports